<template>
  <div class="callout-wraper">
    <tk-flex class="callout full" middle v-for="(item, index) in value" :class="type(item)" :key="index">
      <div class="callout-body fill">
        <div class="title m-b-10" v-if="item.title">{{item.title}}</div>
        <p class="body">{{item.body}}</p>
      </div>
      <v-btn icon class="del" @click.native="del(index)" v-if="item.deletable"><v-icon>clear</v-icon></v-btn>
    </tk-flex>
  </div>
</template>
<script>
export default {
  name: 'callout',
  methods: {
    del (index) {
      let v = JSON.parse(JSON.stringify(this.value))
      v.splice(index, 1)
      this.$emit('update:value', v)
    },
    type (item) {
      return item.type ? `callout-${item.type}` : 'callout-info'
    }
  },
  props: {
    value: Array
  }
}
</script>
<style lang="scss" scoped>
  .callout{
    margin: 20px 0;
    padding: 20px;
    border-left: 3px solid #eee;
    .title{
      font-size: 18px;
    }
    .del {
      margin-left: 20px;
    }
  }
  .callout-info {
    background-color: #f4f8fa;
    border-color: #00BCD4;
    .title {
      color: #00BCD4;
    }
  }
  .callout-success {
    background-color:#f3faf3;
    border-color: #8BC34A;
    .title {
      color: #8BC34A;
    }
  }
  .callout-danger {
    background-color: #fdf7f7;
    border-color: #F44336;
    .title {
      color: #F44336;
    }
  }
  .callout-warning {
    background-color: #fcf8f2;
    border-color: #FFCA28;
    .title {
      color: #FFCA28;
    }
  }
</style>
